import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  Stack,
  Divider,
  Typography,
  IconButton,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import GoogleIcon from "@mui/icons-material/Google";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { User } from "../models/user";
import { SignUpCredentials } from "../network/notes_api";
import * as NotesApi from "../network/notes_api";
import { ConflictError } from "../errors/http_errors";
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode"; // ✅ correct


interface SignUpModalProps {
  onDismiss: () => void;
  onSignUpSuccessful: (user: User) => void;
}

const SignUpModal = ({ onDismiss, onSignUpSuccessful }: SignUpModalProps) => {
  const [errorText, setErrorText] = useState<string | null>(null);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<SignUpCredentials>();

  async function onSubmit(credentials: SignUpCredentials) {
    try {
      const newUser = await NotesApi.signUp(credentials);
      onSignUpSuccessful(newUser);
    } catch (error) {
      if (error instanceof ConflictError) {
        setErrorText(error.message);
      } else {
        alert(error);
      }
      console.error(error);
    }
  }
  const handleGoogleSuccess = async (credentialResponse: any) => {
    const credential = credentialResponse.credential;
    if (!credential) return;

    try {
      const user = await NotesApi.loginWithGoogle({ credential });
      onSignUpSuccessful(user);
    } catch (error) {
      console.error("Google login failed:", error);
      setErrorText("Google login failed. Please try again.");
    }
  };

  return (
    <Dialog open onClose={onDismiss} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: "bold", pr: 5 }}>
        Create your account
        <IconButton
        
          aria-label="close"
          onClick={onDismiss}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={3}>
          <Typography variant="body2" color="text.secondary">
            Join to start creating, saving, and exploring smarter routes.
          </Typography>

          {errorText && <Alert severity="error">{errorText}</Alert>}

          {/* <Button
            variant="outlined"
            startIcon={<GoogleIcon />}
            onClick={handleGoogleSignUp}
            sx={{ textTransform: "none" }}
          >
            Sign up with Google
          </Button> */}
            <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => setErrorText("Google sign-up failed.")}
            text="signup_with"
          />

          <Divider>or sign up with email</Divider>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={2}>
              <TextField
                label="Username"
                placeholder="e.g. adventurer123"
                fullWidth
                variant="outlined"
                {...register("username", { required: "Username is required" })}
                error={!!errors.username}
                helperText={errors.username?.message}
              />

              <TextField
                label="Email"
                placeholder="you@example.com"
                type="email"
                fullWidth
                variant="outlined"
                {...register("email", { required: "Email is required" })}
                error={!!errors.email}
                helperText={errors.email?.message}
              />

              <TextField
                label="Password"
                type="password"
                placeholder="••••••••"
                fullWidth
                variant="outlined"
                {...register("password", { required: "Password is required" })}
                error={!!errors.password}
                helperText={errors.password?.message}
              />

              {/* <Typography variant="caption" color="text.secondary">
                We’ll never share your details. No spam, ever.
              </Typography> */}

              <Button
                style={{backgroundColor:'black'}}
                type="submit"
                variant="contained"
                fullWidth
                disabled={isSubmitting}
              >
                Create Account
              </Button>
            </Stack>
          </form>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Typography variant="body2" sx={{ mx: "auto", pb: 1 }} color="text.secondary">
          Already have an account?{" "}
          <Button onClick={onDismiss} size="small">
            Log In
          </Button>
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default SignUpModal;
